import {Text} from "@chakra-ui/react";
import React from "react";

export default function Truncate({text, length}) {
	function getText() {
		return text.length > length ? `${text.substring(0, length)}...` : text;
	}
	return <Text dangerouslySetInnerHTML={{__html: getText()}}></Text>;
}
